import React from "react";
import CurrencyFormat from "react-currency-format";
import { Tooltip } from "../../../components/Tooltip";

export const ReadOnlyInfo = (props: any) => {
  const { label, data, currency, toolTip } = props;
  return (
    <div>
      <div style={{ display: "flex" }}>
        <p className='label-text tw-mb-1'> {label} </p>
        {toolTip && <Tooltip> {toolTip} </Tooltip>}
      </div>
      {currency && (
        <CurrencyFormat
          value={data}
          displayType={"text"}
          prefix={"$"}
          thousandSeparator={true}
          style={{ fontSize: 18 }}
        />
      )}
      {!currency && <p className='secondaryText'> {data || "--"} </p>}
    </div>
  );
};
